import { environment } from '@lla-platform/core/core-util'

export const STOCKABLE_API_URL = {
  stockableBase: (locationId: string) => `${environment.apiUrl}/stockables/${locationId}`,
  replaceStockables: `${environment.apiUrl}/stockables/replace`
}
